import { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function LoginModal({ onClose }) {
  const { login, signup }       = useAuth();
  const [modo, setModo]         = useState('login'); // 'login' | 'signup'
  const [nome, setNome]         = useState('');
  const [email, setEmail]       = useState('');
  const [senha, setSenha]       = useState('');
  const [senha2, setSenha2]     = useState('');
  const [loading, setLoading]   = useState(false);
  const [erro, setErro]         = useState('');

  const ERROS = {
    'auth/invalid-credential':    'Email ou senha incorretos.',
    'auth/user-not-found':        'Usuário não encontrado.',
    'auth/wrong-password':        'Senha incorreta.',
    'auth/too-many-requests':     'Muitas tentativas. Aguarde.',
    'auth/invalid-email':         'Email inválido.',
    'auth/email-already-in-use':  'Este email já está cadastrado.',
    'auth/weak-password':         'Senha fraca. Use pelo menos 6 caracteres.',
  };

  const entrar = async (e) => {
    e.preventDefault();
    setErro('');
    if (modo === 'signup') {
      if (!nome.trim()) { setErro('Informe seu nome.'); return; }
      if (senha !== senha2) { setErro('As senhas não coincidem.'); return; }
      if (senha.length < 6) { setErro('Senha deve ter ao menos 6 caracteres.'); return; }
    }
    setLoading(true);
    try {
      if (modo === 'login') {
        await login(email, senha);
      } else {
        await signup(nome, email, senha);
      }
      onClose();
    } catch(err) {
      setErro(ERROS[err.code] || 'Erro inesperado. Tente novamente.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 999,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}
      onClick={e => e.target === e.currentTarget && onClose()}>

      <div style={{
        background: '#fff', borderRadius: '20px', padding: '36px',
        width: '400px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)'
      }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{
            width: '48px', height: '48px', borderRadius: '13px',
            background: 'linear-gradient(135deg, #6c47ff, #5535e0)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 12px', color: '#fff', fontWeight: '900', fontSize: '18px',
            boxShadow: '0 6px 20px rgba(108,71,255,0.35)'
          }}>FL</div>
          <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '20px', fontWeight: '800' }}>
            Fa<span style={{ color: '#6c47ff' }}>Lei</span>
          </div>
        </div>

        {/* Toggle login/signup */}
        <div style={{ display: 'flex', background: '#f0f0f8',
          borderRadius: '10px', padding: '3px', marginBottom: '24px' }}>
          {['login','signup'].map(m => (
            <button key={m} onClick={() => { setModo(m); setErro(''); }}
              style={{
                flex: 1, padding: '8px', borderRadius: '8px', border: 'none',
                fontSize: '13px', fontWeight: '600', cursor: 'pointer',
                background: modo === m ? '#fff' : 'transparent',
                color: modo === m ? '#6c47ff' : '#9898b8',
                boxShadow: modo === m ? '0 1px 4px rgba(0,0,0,0.1)' : 'none',
                transition: 'all 0.2s'
              }}>
              {m === 'login' ? 'Entrar' : 'Criar conta'}
            </button>
          ))}
        </div>

        <form onSubmit={entrar}>
          {modo === 'signup' && (
            <div style={{ marginBottom: '14px' }}>
              <label style={lbl}>Seu nome</label>
              <input value={nome} onChange={e => setNome(e.target.value)}
                placeholder="Ex: João Silva" style={inp} autoFocus />
            </div>
          )}

          <div style={{ marginBottom: '14px' }}>
            <label style={lbl}>Email</label>
            <input type="email" value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="seu@email.com" style={inp}
              autoFocus={modo === 'login'} />
          </div>

          <div style={{ marginBottom: modo === 'signup' ? '14px' : '20px' }}>
            <label style={lbl}>Senha</label>
            <input type="password" value={senha}
              onChange={e => setSenha(e.target.value)}
              placeholder="••••••••" style={inp} />
          </div>

          {modo === 'signup' && (
            <div style={{ marginBottom: '20px' }}>
              <label style={lbl}>Confirmar senha</label>
              <input type="password" value={senha2}
                onChange={e => setSenha2(e.target.value)}
                placeholder="••••••••" style={inp} />
            </div>
          )}

          {erro && (
            <div style={{
              padding: '10px 14px', borderRadius: '9px', marginBottom: '14px',
              fontSize: '12px', background: 'rgba(239,68,68,0.08)',
              color: '#dc2626', border: '1px solid rgba(239,68,68,0.2)',
              fontFamily: 'monospace'
            }}>{erro}</div>
          )}

          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '13px',
            background: loading ? '#9898b8' : 'linear-gradient(135deg, #6c47ff, #5535e0)',
            color: '#fff', border: 'none', borderRadius: '10px',
            fontSize: '15px', fontWeight: '700',
            cursor: loading ? 'not-allowed' : 'pointer',
            boxShadow: loading ? 'none' : '0 4px 14px rgba(108,71,255,0.4)'
          }}>
            {loading
              ? 'Aguarde...'
              : modo === 'login' ? 'Entrar →' : 'Criar conta →'}
          </button>
        </form>

        {modo === 'signup' && (
          <div style={{ textAlign: 'center', marginTop: '14px',
            fontSize: '11px', color: '#9898b8', lineHeight: '1.6' }}>
            Ao criar sua conta você concorda com os<br />
            termos de uso da plataforma FaLei.
          </div>
        )}
      </div>
    </div>
  );
}

const lbl = {
  fontSize: '11px', fontWeight: '700', color: '#52526e',
  textTransform: 'uppercase', letterSpacing: '0.06em',
  fontFamily: 'monospace', display: 'block', marginBottom: '6px'
};
const inp = {
  width: '100%', padding: '11px 13px', borderRadius: '9px',
  border: '1.5px solid rgba(0,0,0,0.1)', fontSize: '14px',
  background: '#f8f8fc', outline: 'none', boxSizing: 'border-box',
  fontFamily: 'DM Sans, sans-serif', color: '#0a0a18'
};